export default {
  sm: `
    데이터센터 각 글로벌은 글로벌 주요 10개 
    지역의 인프라 거점을 잇는 네트워크를 
    보유하고 있으며 네이버와 LINE의 글로벌 
    인프라를 기반으로 언제 어디서나 동일한 
    서비스 이용이 가능한 클라우드 서비스 
    리전을 확대하고 있습니다. 
  `,
  md: `
    데이터센터 각 글로벌은 글로벌 주요 10개 지역의 인프라 거점을 잇는
    네트워크를 보유하고 있으며 네이버와 LINE의 글로벌 인프라를 기반으로
    언제 어디서나 동일한 서비스 이용이 가능한 클라우드 서비스 리전을 확대하고 있습니다.
  `,
  lg: `
    데이터센터 각 글로벌은 글로벌 주요 10개 지역의 인프라 거점을 잇는
    네트워크를 보유하고 있으며 네이버와 LINE의 글로벌 인프라를 기반으로
    언제 어디서나 동일한 서비스 이용이 가능한 클라우드 서비스 리전을 확대하고 있습니다.
  `,
  xxl: `
    데이터센터 각 글로벌은 글로벌 주요 10개 지역의 인프라 거점을 잇는
    네트워크를 보유하고 있으며 네이버와 LINE의 글로벌 인프라를 기반으로
    언제 어디서나 동일한 서비스 이용이 가능한 클라우드 서비스 리전을 확대하고 있습니다.
  `,
};
